import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

import { commonContentAttributes } from "./commonContentAttributes";

export const okpo_2: SugarElementInfo = {
    name: "okpo_2",
    availableChildren: { type: AvailableChildrenType.Any },
    attributes: commonContentAttributes,
};
